// Achats validés avant l'enregistrement de la nature (avant le 13/10/2026) :
// attribuer biens / services sans revalider. Pour un service (TVA facturée,
// sans option du fournisseur pour les débits), l'enregistrement crée une
// écriture de correction : TVA mise en attente jusqu'au paiement — uniquement
// sur clic de l'utilisateur.
import { useCallback, useEffect, useState } from "react";
import api from "../services/api";

const eur = (n) => `${Number(n || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
const frDate = (d) => (d ? String(d).slice(0, 10).split("-").reverse().join("/") : "—");

export default function PurchaseNatureMissing({ onChanged }) {
  const [rows, setRows] = useState([]);
  const [choice, setChoice] = useState({});   // id → { nature, debits }
  const [busy, setBusy] = useState(null);
  const [msg, setMsg] = useState("");
  const [open, setOpen] = useState(true);

  const load = useCallback(() => {
    api.purchases.natureMissing().then(r => {
      setRows(r || []);
      setChoice(c => { const n = { ...c }; for (const x of r || []) if (!n[x.id]) n[x.id] = { nature: x.suggested_nature || "", debits: false }; return n; });
    }).catch(() => setRows([]));
  }, []);
  useEffect(() => { load(); }, [load]);

  if (!rows.length) return null;

  const save = async (row) => {
    const c = choice[row.id] || {};
    if (!c.nature) return;
    const willCorrect = row.vat_on_invoice && c.nature === "services" && !c.debits;
    if (willCorrect && !window.confirm(`${row.number} — service : la TVA de ${eur(row.tva_amount)} sera mise en attente jusqu'au paiement du fournisseur (écriture de correction à la date de la facture${row.status === "paid" ? ", puis TVA déductible à la date du paiement" : ""}). Continuer ?`)) return;
    setBusy(row.id); setMsg("");
    try {
      const r = await api.purchases.setNature(row.id, { operation_nature: c.nature, supplier_vat_on_debits: !!c.debits });
      setMsg(r.correction
        ? `${row.number} : nature « services » enregistrée — ${eur(r.correction.moved_to_pending)} de TVA mis en attente${r.correction.transferred_on_payments ? `, ${eur(r.correction.transferred_on_payments)} déjà déductibles (paiement connu)` : ""}.`
        : `${row.number} : nature « ${c.nature} » enregistrée.`);
      load(); onChanged && onChanged();
    } catch (e) { setMsg(e.message); }
    finally { setBusy(null); }
  };

  return (
    <div className="card" style={{ marginBottom: 14, border: "1px solid #f59e0b55" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 14 }}>⚠ {rows.length} achat(s) validé(s) sans nature biens / services</div>
          <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 2 }}>
            Validés avant le 13/10/2026 : indiquez leur nature pour que la synthèse TVA soit juste (biens : TVA déductible à la facture ; services : au paiement). Rien n'est revalidé.
          </div>
        </div>
        <button className="btn" style={{ fontSize: 11 }} onClick={() => setOpen(o => !o)}>{open ? "Replier" : "Afficher"}</button>
      </div>
      {msg && <div style={{ fontSize: 12.5, marginTop: 8, padding: "6px 10px", background: "#f0fdf9", borderRadius: 8 }}>{msg}</div>}
      {open && (
        <div style={{ overflowX: "auto", marginTop: 10 }}>
          <table className="table" style={{ width: "100%", fontSize: 12 }}>
            <thead><tr><th>Pièce</th><th>Fournisseur</th><th>Date</th><th>Compte</th><th style={{ textAlign: "right" }}>TVA</th><th>Nature</th><th></th></tr></thead>
            <tbody>
              {rows.map(x => {
                const c = choice[x.id] || {};
                return (
                  <tr key={x.id}>
                    <td>{x.number}</td><td>{x.supplier_name}</td><td>{frDate(x.date)}</td><td>{x.account}</td>
                    <td style={{ textAlign: "right" }}>{eur(x.tva_amount)}</td>
                    <td>
                      <select className="input" style={{ fontSize: 12, padding: "2px 6px", width: "auto" }} value={c.nature || ""}
                        onChange={e => setChoice(s => ({ ...s, [x.id]: { ...c, nature: e.target.value } }))}>
                        <option value="" disabled>— À choisir —</option>
                        <option value="biens">Biens</option>
                        <option value="services">Services</option>
                      </select>
                      {x.suggested_nature && c.nature === x.suggested_nature && <span style={{ fontSize: 10.5, color: "var(--text-muted)", marginLeft: 6 }}>suggéré ({x.suggestion_reason})</span>}
                      {c.nature === "services" && x.vat_on_invoice && (
                        <label style={{ display: "block", fontSize: 11, marginTop: 3 }}>
                          <input type="checkbox" checked={!!c.debits} onChange={e => setChoice(s => ({ ...s, [x.id]: { ...c, debits: e.target.checked } }))} /> fournisseur ayant opté pour les débits
                        </label>
                      )}
                    </td>
                    <td><button className="btn primary" style={{ fontSize: 11, padding: "3px 10px" }} disabled={!c.nature || busy === x.id} onClick={() => save(x)}>{busy === x.id ? "…" : "Enregistrer"}</button></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
